export const department_details = [
  {
    key:"1",
    Department: "Finance",
    NoOfEmployees: "20",
    Status: "Active",
  },
  {
    key:"2",
    Department: "Application Development",
    NoOfEmployees: "30",
    Status: "Active",
  },
  {
    key:"3",
    Department: "IT Management",
    NoOfEmployees: "15",
    Status: "Active",
  },
  {
    key:"4",
    Department: "Web Development",
    NoOfEmployees: "20",
    Status: "Active",
  },
  {
    key:"5",
    Department: "Sales",
    NoOfEmployees: "20",
    Status: "Active",
  },
  {
    key:"6",
    Department: "UI / UX",
    NoOfEmployees: "30",
    Status: "Active",
  },
  {
    key:"7",
    Department: "Account Management",
    NoOfEmployees: "15",
    Status: "Active",
  },
  {
    key:"8",
    Department: "Marketing",
    NoOfEmployees: "10",
    Status: "Inactive",
  },
  {
    key:"9",
    Department: "Administration",
    NoOfEmployees: "05",
    Status: "Active",
  },
  {
    key:"10",
    Department: "Business Development",
    NoOfEmployees: "07",
    Status: "Active",
  },
];
